import React from 'react'
import { connect } from 'react-redux'
import Card, { TitleCard } from '../../core/Card'
import { push, goBack } from 'react-router-redux'
import Line from '../../core/Line'
import { ForwardIcon, Icon, PlusIcon, MarkerIcon,
  BankCardIcon
} from '../../core/icons'
import {
  BrowserRouter as Router,
  Route,
  Link,
} from 'react-router-dom'
import { Slider, Select, Button, Col, Row, Popover, Icon as AIcon, Switch, message, Popconfirm } from 'antd';
import {toggle, unlink, updateLogin, refresh} from './actions'
import styled from 'styled-components'

const AccountLine = styled(Line)`
  div {
    cursor: default;
  }
`

const BankCardLine = ({toggle, meta: {name, number}, excluded, plaid_subtype, token_id}) =>
  <AccountLine>
      <Col span={2}>
        <BankCardIcon/>
      </Col>
      <Col span={20}>
        {name}
        <div style={{fontSize:14, opacity: .6}}>
          ****** {number}
        </div>
      </Col>
      <Col span={1}>
        <Switch checked={!excluded} onClick={()=>toggle(token_id, !excluded)}/>
      </Col>
  </AccountLine>

const Accounts = ({institution_accounts, toggle}) =>
  <div>
    { institution_accounts ? institution_accounts.map((props, i)=> <BankCardLine key={i} toggle={toggle} {...props}/>)
      : "No accounts available for this institution."
    }
  </div>


const mapDispatchToProps = (dispatch) => {
  return {
    toggle: (id, excluded)=>dispatch(toggle(id, excluded)),
  }
}

const mapStateToProps = ({models:{user:{ institution_users }}}, {tokenId}) => {

  return {
    ...institution_users.find( ({token_id})=>token_id==tokenId )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Accounts)



// WEBPACK FOOTER //
// ./src/account/bank-card/Accounts.js